import { render } from "./ServiceListLondon.vue?vue&type=template&id=243b58a2&scoped=true"
import script from "./ServiceListLondon.vue?vue&type=script&lang=js"
export * from "./ServiceListLondon.vue?vue&type=script&lang=js"

import "./ServiceListLondon.vue?vue&type=style&index=0&id=243b58a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243b58a2"]])

export default __exports__